import styled from 'styled-components';
import { Buttons } from '@taxdown/piccolo-web';

export const SocialButton = styled(Buttons.Classic)`
  svg {
    stroke: none;
  }
`;
